export default function WeekView({ days, onSelectDate }) {
  return (
    <div className="grid grid-cols-7 gap-3" data-testid="schedule-week-view">
      {days.map((d) => (
        <div
          key={d.date}
          data-testid={`week-day-${d.date}`}
          onClick={() => onSelectDate(d.date)}
          className="bg-white border border-[#E2E8F0] rounded-lg p-3 cursor-pointer hover:border-[#76C121] transition-colors duration-200 min-h-[140px]"
        >
          <p className="text-xs font-semibold text-[#4B5563] uppercase">{d.label}</p>
          <p className="text-sm font-medium text-[#1C1C1E] mb-2">{d.dayNum}</p>
          <div className="space-y-1">
            {d.events.slice(0, 3).map((ev) => (
              <p key={ev.id} className="text-[10px] truncate bg-[#F8F9FA] rounded px-1.5 py-0.5 text-[#4B5563]">{ev.start_time} {ev.title}</p>
            ))}
            {d.events.length > 3 && <p className="text-[10px] text-[#00823B] font-medium">+{d.events.length - 3} more</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
